/**
 * Contents of this file were produced with a help of a code generation tool and
 * subsequently reviewed and edited by a human.
 *
 * While some of the code was created by an AI assisted service, manual adjustments
 * have been made to ensure correctness, readability, functionality and compliance
 * to Avalara's coding standards and guidelines. Any future modifications should
 * be approached with caution to avoid overwriting the manual changes.
 *
 * This source code is owned by Avalara Inc. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Proprietary and confidential.
 *
 * For more information, refer to the documentation or contact the development team.
 */

export class DebugLogger {
    private static debugEnabled: boolean | null = null;

    private static isDebugEnabled(): boolean {
        if (DebugLogger.debugEnabled !== null) {
            return DebugLogger.debugEnabled;
        }

        try {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            const getConfig = require("../config").default as () => { appEnv: string };
            const { appEnv } = getConfig();
            const normalizedEnv = (appEnv as string)?.trim()?.toLowerCase();
            DebugLogger.debugEnabled = normalizedEnv !== "prd" && normalizedEnv !== "sbx";
        } catch {
            // If config fails, default to enabled for development
            DebugLogger.debugEnabled = true;
        }

        return DebugLogger.debugEnabled;
    }

    /**
     * Logs messages only in non-production environments (disabled in prd/sbx).
     *
     * @param message - The log message
     * @param data - Optional additional data to log
     * @param scope - Optional scope prefix (defaults to "App")
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static log(message: string, data?: any, scope: string = "App"): void {
        if (this.isDebugEnabled()) {
            if (data !== undefined && data !== null) {
                // eslint-disable-next-line no-console
                console.log(`[${scope}] ${message}`, data);
            } else {
                // eslint-disable-next-line no-console
                console.log(`[${scope}] ${message}`);
            }
        }
    }
}
